import type { EnvelopeStatusFilter } from '@/api/v1/ecm/envelopes'
import { isEnvelopeStatusFilter } from '@/api/v1/ecm/envelopes'

export type EnvelopesStatusPath = `/envelopes/${EnvelopeStatusFilter}`

export function envelopesStatusPath(
  status: EnvelopeStatusFilter,
): EnvelopesStatusPath {
  return `/envelopes/${status}`
}

export function envelopesStatusFromPath(
  pathname: string,
): EnvelopeStatusFilter | null {
  const [, root, segment] = pathname.split('/')
  return root === 'envelopes' && isEnvelopeStatusFilter(segment)
    ? segment
    : null
}

export function isEnvelopesListPath(pathname: string): boolean {
  return (
    envelopesStatusFromPath(pathname) !== null &&
    pathname.replace(/\/$/, '').split('/').length === 3
  )
}
